import { render, staticRenderFns } from "./SpaceStatistic.vue?vue&type=template&id=c4fdbc6a&scoped=true"
import script from "./SpaceStatistic.vue?vue&type=script&lang=ts"
export * from "./SpaceStatistic.vue?vue&type=script&lang=ts"
import style0 from "./SpaceStatistic.vue?vue&type=style&index=0&id=c4fdbc6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fdbc6a",
  null
  
)

export default component.exports